module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.params && _vm.params.isActive) ? _c('div', [_c('ModalDefault', {
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "close": function($event) {
        _vm.close();
      }
    }
  }, [_c('template', {
    slot: "main"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center container flex-column"
  }, [_c('p', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t("common.remove")))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "html-safe",
      rawName: "v-html-safe",
      value: (
        _vm.$t('zoneGroups.deleteFromBrand', {
          group: _vm.params.brandHasZoneGroup.zoneGroups.name.toUpperCase(),
          brand: _vm.params.brandHasZoneGroup.brand.name.toUpperCase()
        })
      ),
      expression: "\n                        $t('zoneGroups.deleteFromBrand', {\n                            group: params.brandHasZoneGroup.zoneGroups.name.toUpperCase(),\n                            brand: params.brandHasZoneGroup.brand.name.toUpperCase()\n                        })\n                    "
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('ClientColorButton', {
    staticClass: "mr-3",
    attrs: {
      "background-color": _vm.currentBrand.linksColor
    },
    on: {
      "click": function($event) {
        _vm.removeZoneGroups();
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("common.remove")) + "\n                    ")]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "inactiveColor": true
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.close();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("actions.cancel")))])], 1)])])], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59354660","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/zoneGroups/DeleteZoneGroups.vue
// module id = 3204
// module chunks = 0